export const LAYER_LIMIT = 20;
export const DEFAULT_LAYER_LIMIT=3;

export const testIds = {
    "sidebar": "867730",
    "map": "b28582",
    "zoomInBtn": "ad1cfd",
    "zoomOutBtn": "06b943",
    "addEdgeBtn": "d14a0c",
    "addNodeBtn": "f315a9",
    "editEdgeToggleBtn": "fdc230",
    "editNodeToggleBtn": "f8f403"
};

